import React from 'react';

import ProtectedData from 'pages/components/ProtectedData';

import useStyles from './styles';

interface Props {
    viewCount: number;
    className?: string;
}

const ViewCount: React.FC<Props> = ({ viewCount, className }) => {
    const { classes, cx } = useStyles();

    return (
        <span className={cx(classes.container, className)}>
            <span>👁</span>
            &nbsp;
            <ProtectedData data={viewCount}>
                {({ content }) => <span className={classes.primary}>{content}</span>}
            </ProtectedData>
            &nbsp;
            <span className={classes.secondary}>{'Views'}</span>
        </span>
    );
};

export default ViewCount;
